import { QueryClient } from "@tanstack/react-query";

/* Eén gedeelde QueryClient: data blijft vers (poll elke 15 s, herladen bij focus/online), en elke schrijfactie
   (POST/PUT/PATCH/DELETE) ververst direct alle schermen — zie api.js. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchInterval: 15_000,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 1,
    },
  },
});

let timer = null;
export const refreshEverything = () => {
  clearTimeout(timer);
  timer = setTimeout(() => queryClient.invalidateQueries(), 150);
};
